"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
var _material = require("@mui/material");
var _AccessAvatar = _interopRequireDefault(require("./AccessAvatar"));
var _AccessName = _interopRequireDefault(require("./AccessName"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function AccessesPopup(_ref) {
  var accesses = _ref.accesses,
    onClose = _ref.onClose;
  var _useState = (0, _react.useState)(accesses),
    _useState2 = _slicedToArray(_useState, 2),
    filtered = _useState2[0],
    setFiltered = _useState2[1];
  var onSearch = (0, _react.useCallback)(function (event, search) {
    event.stopPropagation();
    if (search) {
      var fixed = search.toLowerCase();
      var _filtered = accesses.filter(function (el) {
        return !!el.tenant;
      }).filter(function (el) {
        return el.tenant.name.toLowerCase().indexOf(fixed) >= 0;
      });
      setFiltered(_filtered);
    } else {
      setFiltered(accesses);
    }
  }, [accesses]);
  return /*#__PURE__*/_react["default"].createElement(_commons.DialogPopup, {
    open: true,
    title: (0, _core.translate)('accesses_button.title'),
    onClose: onClose,
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_commons.SearchFormFilter, {
    label: (0, _core.translate)('accesses_button.filter'),
    onUpdated: onSearch
  }), /*#__PURE__*/_react["default"].createElement(_material.Card, {
    variant: "outlined",
    sx: {
      mt: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_commons.DataGrid, {
    items: filtered,
    getId: function getId(el) {
      return el.id;
    },
    loading: false,
    columns: [{
      title: (0, _core.translate)('accesses_button.name'),
      converter: function converter(access) {
        return /*#__PURE__*/_react["default"].createElement(_material.Stack, {
          direction: "row",
          justifyContent: "flex-start",
          alignContent: "center",
          alignItems: "center",
          spacing: 1
        }, /*#__PURE__*/_react["default"].createElement(_AccessAvatar["default"], {
          access: access,
          size: 6
        }), /*#__PURE__*/_react["default"].createElement(_AccessName["default"], {
          access: access
        }));
      },
      id: 'access'
    }, {
      title: /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
        size: "small",
        style: {
          visibility: 'hidden'
        },
        disabled: true
      }, /*#__PURE__*/_react["default"].createElement(_commons.RightIcon, null)),
      converter: function converter(access) {
        var _a;
        return /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
          size: "small",
          component: "a",
          href: ((_a = access.tenant) === null || _a === void 0 ? void 0 : _a.id) ? "/t/".concat(access.tenant.id, "/") : '/'
        }, /*#__PURE__*/_react["default"].createElement(_commons.RightIcon, null));
      },
      id: 'actions',
      fixed: 'right',
      width: 60,
      textAlign: 'center'
    }]
  })));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(AccessesPopup);